import { CurrentUserState } from './types';
import { createStoreModule } from '@/_core/fluxstore';
import { IAction } from '@/_core/fluxstore/types';

const initState = () => {
    return new CurrentUserState();
};

export const useCurrentUserModule = createStoreModule<CurrentUserState, IAction<CurrentUserState>>(initState, 'currentuser');
